import React from 'react'
import './Table.css'

function Table({night, countries}) {
    return (
        <div className={night ? "table_night" : "table"}>
            {countries.map(({ country, cases })=>(
                <tr>
                    <td>{country}</td>
                    <td><strong>{cases}</strong></td>
                </tr>
            ))}
        </div>
    )
}

export default Table;
